<template>
  <header class="flex flex-wrap justify-between items-center px-2 bg-white border-b border-section_border">
    <p class="flex-grow">
      <a :href="tohoku_maas_url()">
        <img src="@/assets/images/tohoku-maas-sendai.png" alt="$t('tour_tohoku_maas')" class="header-logo" width="203" height="30" />
      </a>
    </p>
    <template v-if="$route.name =='map' || $route.name =='current' || $route.name =='location'">
      <router-link :to="toPlan" class="flex justify-center items-center mr-2 px-2 bg-link text-white link-header w-24 border-radius-round">
        <img src="@/assets/images/icon-header-plan.svg" alt="map" class="h-3 pr-1" />
        <span class="block whitespace-nowrap text-xs">{{ $t('tour_plan_label') }}</span>
      </router-link>
    </template>
    <template v-if="$route.name == 'root' || $route.name == 'top' || $route.name == 'plans'">
      <router-link :to="toMap" class="flex justify-center items-center mr-2 px-2 bg-link text-white link-header w-20 border-radius-round">
        <img src="@/assets/images/map-wt.png" alt="map" class="h-3 pr-1" />
        <span class="block whitespace-nowrap text-xs">{{ $t('tour_map_label') }}</span>
      </router-link>
    </template>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from "../../constants";

export default {
  name: 'TheHeader',
  computed: {
    ...mapGetters({
      from: 'map/getFrom',
      lang: 'user/getLang'
    }),
    toPlan: function () {
      if (this.from.name) {
        if (this.from.name == 'root') {
          return {
            name: 'plans'
          }
        } else if ((this.from.name == 'createReservation') || (this.from.name == 'reservation')) {
          return {
            name: 'plans'
          }
        } else if (this.from.name == 'top') {
          return {
            name: 'top',
            params: { lang: this.lang }
          }
        } else {
          return {
            name: this.from.name,
            params: this.from.params
          }
        }
      } else {
        // NOTE: /mapに直接きた場合
        if (this.lang && this.lang !== 'ja') {
          return {
            name: 'top',
            params: { lang: this.lang}
          }
        } else {
          return {
            name: 'plans'
          }
        }
      }
    },
    toMap: function () {
      return {
        name: 'map',
        params: { lang: this.$store.getters['user/getLang'] }
      }
    }
  },
  methods: {
    tohoku_maas_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    }
  }
}
</script>
